import Vue from 'vue';
import uuid from '@/libs/uuid'

export default Vue.extend({
  data() {
    return {
      id: undefined,
      data: false, 
      disable: false,
      trueValue: "Y",
      falseValue: "N",
      isSelecBoxShow: false,
      selects: [],
      selectKey: ''
    }
  }, watch: {
    'value': { 
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {

          let tVal;

          if(typeof this.params.colDef.cellRendererParams === 'function') {
            let data = this.params.colDef.cellRendererParams(this.params);
            tVal = data.trueValue;
            this.disable = data.disable;
            this.isSelecBoxShow = data.isSelecBoxShow;
          } else{
            tVal = this.params.colDef.cellRendererParams?.trueValue;
            this.disable = this.params.colDef.cellRendererParams?.disable;
            this.isSelecBoxShow = this.params.colDef.cellRendererParams?.isSelecBoxShow;
          }
          this.data = this.params.value === (tVal || this.trueValue) ? true : false;
          if(this.isSelecBoxShow) {
            this.selects = [{key: '01', value: 'M/A 계약분'}, {key: '02', value: '미방문(접수취소)'}]
          }
        })
      }
    }
  },
  created() {
    this.id = uuid()
  },
  methods: {
    checkedHandler(target) {
      let checked = null
      
      if(typeof this.params.colDef.cellRendererParams === 'function') {
        checked = target ? this.trueValue : this.falseValue;
      } else {
        if(this.params.colDef.cellRendererParams === undefined){        
          checked = target ? this.trueValue : this.falseValue;
        }else{
          
          let fValue = typeof this.params.colDef.cellRendererParams.falseValue === 'boolean' ? false : this.params.colDef.cellRendererParams.falseValue
  
          checked = target ? this.params.colDef.cellRendererParams?.trueValue : fValue
        }
      }

      let colId = this.params.column.colId

      this.params.node.setDataValue(colId, checked);
    }
  },
    template: 
    `
    <div v-if="isSelecBoxShow && !data">
      <el-form>
        <el-row :gutter="24">
          <el-col :span="9">
            <el-form-item>
              <el-radio-group v-model="data" :disabled="disable" @change="checkedHandler($event)">
                <el-radio :label="true">유</el-radio>
                <el-radio :label="false">무</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <el-form-item>
              <el-select v-model="selectKey">
                <el-option
                    v-for="item in selects"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-else>
      <el-radio-group v-model="data" :disabled="disable" @change="checkedHandler($event)">
        <el-radio :label="true">유</el-radio>
        <el-radio :label="false">무</el-radio>
      </el-radio-group>
    </div>
    `,
});